import { action as apiAction } from 'api/Api'
import {
  removeItem as removeItemFromChecklist
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  checklistItemId: number
  checklistId: number
}

const requestRemoveChecklistItem = (payload: Payload) => async dispatch => {
  const { checklistItemId, checklistId } = payload

  const optimisticAction = optimisticDispatch(dispatch, removeItemFromChecklist({
    elementId: checklistId,
    itemId: checklistItemId
  }))

  try {
    await apiAction('RemoveChecklistItem', {
      id: checklistItemId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestRemoveChecklistItem
